import { Button, Modal } from "react-bootstrap";
import { useResetAssessment } from "../assessment_hooks";

export default function ResetModal({ isOpen, onClose }) {
  const { resetUserAssessment, resetting } = useResetAssessment();

  return (
    <Modal show={isOpen} centered onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Assessment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You've already finished all steps. Do you want to reset the assessment
        and start from beginning? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={resetUserAssessment} disabled={resetting}>
          Reset Assessment
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
